import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {EditModule} from "./edit/edit.module";

@NgModule({
  imports: [
    CommonModule,
    EditModule
  ],
  declarations: []
})
export class BoundariesActivityModule { }
